<template>
<div class="chapter">
<div class="inner_page">
<div id="a04_maps">
<p class="map">THE MAPS</p>
<p class="map1">Large-scale versions of the maps located at the back can be downloaded from the book’s page on the publishers’ websites.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_maps.vue?4c23a982